import React from 'react'
import { FormattedMessage } from 'react-intl'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { BigButton } from '../../../../../../components/button'
import { useLogin } from '../../../../../../hooks/common'
import { useCallback } from 'react'
import { TOGGLE_UI_LOGIN } from '../../../../../../../store/actions/ui'
import { action_fetch_cart } from '../../../../../../../store/actions/pages/cart'
import { useDispatch } from 'react-redux'

export default props => {
    useStyles(classes)

    const isLogin = useLogin()

    const dispatch = useDispatch()

    const shopNowHandle = useCallback(e => {
        window.location = '/'
    }, [])

    const loginHandle = useCallback(e => {
        dispatch({
            type: TOGGLE_UI_LOGIN,
            payload: {
                showLogin: true,
                eventType:"空车",
                callBack: async () => {
                    dispatch(action_fetch_cart())
                }
            }
        })
    }, [])

    return <div className={classes.Empty}>
        <img className={classes.Icon} src="https://image.geeko.ltd/chicme/20221107/shopping_bag_empty.svg" />
        <div className={classes.Title}>
            <FormattedMessage id="shopping_bag_empty" defaultMessage="Your shopping bag is empty!" />
        </div>
        {
            !isLogin && <div className={classes.Content}>
                <FormattedMessage id="sign_in_to_view_bag" defaultMessage="sign in to view your cart and start shopping" />
            </div>
        }
        <div className={classes.Buttons}>

            {
                !isLogin && <div>
                    <BigButton onClick={loginHandle}><FormattedMessage id="sign_in_register" defaultMessage="Sign In / Register" /></BigButton>
                </div>
            }


            <div>
                <BigButton outlined onClick={shopNowHandle}><FormattedMessage id="shop_now" defaultMessage="Shop Now" /></BigButton>
            </div>


        </div>
    </div>
}